import { UPDATE_CALCULATED_TIME_LEFT } from '../constants/actionTypes'

export default (state = 0, action) => {
    switch (action.type) {
        case UPDATE_CALCULATED_TIME_LEFT:
            return action.payload
        default:
            return state
    }
}
